import { Box, Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import { orderStatusFormatted } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useAuthGlobal from "src/context/useAuthGlobal";
import useWarehouseTransferStatus from "src/hooks/warehouse-transfer/useWarehouseTransferStatus";
import useQueryParams from "src/hooks/useQueryParams";
import ExportPrepareProd from "./ExportPrepareProd";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

const commonCss = { fontSzie: "12px", whiteSpace: "nowrap" };
export default function ExportConfirmActionGroup({ item }) {
  const permissionCheck = useRoleCheck();
  const [option] = useQueryParams();
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const { trigger: updateStatus } = useWarehouseTransferStatus();

  const handleUpdateStatus = async (status) => {
    const res = await updateStatus({
      pathIncluded: {
        warehouseId: item?._id,
      },
      body: {
        statusOut: status,
        warehouse: item?.fromWarehouse?._id ?? userMe?.currentWarehouse?._id,
      },
    });

    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  return (
    <Box
      display="flex"
      gap="6px"
      justifyContent="center"
    >
      <Button
        disabled={
          ![orderStatusFormatted.Pending]?.includes(item?.statusOut) ||
          !permissionCheck([PERMISSIONS.PREPARE_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.PREPARE_WAREHOUSETRANSFEREXPORT_OWN])
        }
        size="small"
        variant="contained"
        sx={{ ...commonCss }}
        onClick={() =>
          handleOpenDialog({
            content: <ExportPrepareProd item={item} />,
            size: "xl",
          })
        }
      >
        {option?.tab === "inventory-out-remove" || (item?.statusOut === orderStatusFormatted.Pending && item?.type === "Remove") ? "Kiểm tra" : "Soạn hàng"}
      </Button>
      <Button
        disabled={
          item?.statusOut !== orderStatusFormatted.Pending ||
          item?.orderCode ||
          !permissionCheck([PERMISSIONS.CHANGESTATUS_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.CHANGESTATUS_WAREHOUSETRANSFEREXPORT_OWN])
        }
        size="small"
        variant="outlined"
        sx={{ ...commonCss }}
        onClick={() =>
          handleOpenDialog({
            content: (
              <ConfirmComp
                custom={{
                  label: "Xác nhận hủy xuất hàng",
                }}
                name={item?.name}
                onConfirm={() => handleUpdateStatus(orderStatusFormatted.Canceled)}
              />
            ),
            size: "md",
          })
        }
      >
        Hủy
      </Button>
    </Box>
  );
}
